<template>
  <el-form
    :model="from"
    status-icon
    :rules="rules"
    ref="from"
    label-width="120px"
    class="demo-from"
  >
    <el-form-item label="Password" prop="pass">
      <el-input type="password" v-model="from.pass" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="Confirm" prop="checkPass">
      <el-input type="password" v-model="from.checkPass" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitForm('from')">Submit</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import axios from "axios";
import { url } from "../service/url";
import { mapActions,mapState } from "vuex";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password"));
      } else {
        if (this.from.checkPass !== "") {
          this.$refs.from.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password again"));
      } else if (value !== this.from.pass) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    return {
      from: {
        pass: "",
        checkPass: ""
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  computed:{
        ...mapState('account', ['partner']),
  },
  methods: {
    ...mapActions('account', ['logout']),
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var body = {
            password: this.from.pass
          };
          axios.post(`${url}/partner/${this.partner.id}/password`, body)
            .then(() => {
               this.logout()
            })
            .catch(err => {
              this.$message.error(err.response.data.message);
            })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
